import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full w-min-[360px] flex items-center justify-between p-4 sm:p-8 bg-h-primary-100 rounded-lg" }
const _hoisted_2 = { class: "flex gap-8 items-center w-[80%]" }
const _hoisted_3 = {
  id: "headers",
  class: "flex flex-col gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", { pt: _ctx.title, en: _ctx.titleEN })), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: _ctx.subtitle,
                en: _ctx.subtitleEN,
              })), 1)
        ])
      ]),
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}